/* eslint-disable react/no-did-update-set-state */
import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import firebase from 'firebase/app'
import { Button, Modal, Icon, Form, Checkbox, Header, Loader, Dimmer } from 'semantic-ui-react'

import RestaurantField from '../fields/restaurantsField'
import ItemField from '../fields/itemField'
import DiscountField from '../fields/discountField'
import ShareExpense from '../fields/shareExpense'
import QuantityField from '../fields/quantityField'
import LimitationField from '../fields/LimitationField'
import UserLimitationField from '../fields/UserLimitationField'

import ItemActions from '../../../reducers/itemReducer'
import SpecialDealActions from '../../../reducers/specialDealReducer'

class NewItemForm extends React.PureComponent {
  btnSubmitRef = React.createRef()

  state = {
    selectedRestaurant: null,
    selectedItem: null,
    discountRate: 0,
    isCostSharing: false,
    merchantRate: 0,
    companyRate: 0,
    quantity: 0,
    unlimit: false,
    enableUserLimitation: false,
    limitPerUser: 0,
    saving: false,
  }

  componentDidMount() {
    const { action, item, fetchItems } = this.props

    if (action === 'edit') {
      this.setState(
        {
          selectedRestaurant: item.merchant_id,
          selectedItem: item.key,
          discountRate: item.discount_rate,
          isCostSharing: !!item.cost_sharing,
          merchantRate: _.get(item, 'cost_sharing.merchant', 0),
          companyRate: _.get(item, 'cost_sharing.company', 0),
          enableUserLimitation: item.limit_per_user && item.limit_per_user > 0,
          limitPerUser: item.limit_per_user || 0,
          quantity: item.quantity,
          unlimit: item.unlimit,
        },
        () => fetchItems(item.merchant_id)
      )
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      companyRate: prevCompanyRate,
      merchantRate: prevMerchantRate,
      selectedRestaurant: prevSelectedRestaurant,
    } = prevState
    const { companyRate, merchantRate, discountRate, selectedRestaurant } = this.state
    const { action, fetchItems } = this.props

    if (action === 'new' && prevSelectedRestaurant !== selectedRestaurant) {
      fetchItems(selectedRestaurant)
    }

    if (companyRate !== prevCompanyRate) {
      this.setState({ merchantRate: Number(parseFloat(discountRate - companyRate).toFixed(2)) })
    }

    if (merchantRate !== prevMerchantRate) {
      this.setState({ companyRate: Number(parseFloat(discountRate - merchantRate).toFixed(2)) })
    }
  }

  onShareExpenseCheck = () => {
    const { isCostSharing, discountRate } = this.state
    let shareExpense = {}

    if (!isCostSharing) {
      const shareRate = Number(parseFloat(discountRate / 2).toFixed(2))

      shareExpense = {
        companyRate: shareRate,
        merchantRate: shareRate,
      }
    }

    this.setState({ isCostSharing: !isCostSharing, ...shareExpense })
  }

  onSavePress = async () => {
    const {
      selectedRestaurant,
      selectedItem,
      discountRate,
      isCostSharing,
      merchantRate,
      companyRate,
      enableUserLimitation,
      limitPerUser,
      quantity,
      unlimit,
    } = this.state

    const { onClose, item, items, specialDealKey, action, saveDealItem, restaurants, merchantIds } = this.props
    const itemData = items[selectedRestaurant][selectedItem]

    this.setState({ saving: true })

    const itemRef = firebase.firestore().collection('special_deals').doc(specialDealKey)
    const markUpPercentage = restaurants[selectedRestaurant].mark_up_percentage || 0

    const data = {
      quantity,
      sold: (item && item.sold) || 0,
      sold_out: (item && item.sold_out) || false,
      key: selectedItem,
      name: itemData.name,
      unlimit: unlimit || null,
      discount_rate: discountRate,
      merchant_id: selectedRestaurant,
      price: Number(itemData.current_price),
      limit_per_user: enableUserLimitation ? Number(limitPerUser || 0) : 0,
      mark_up_percentage: markUpPercentage,
      ...(itemData.images ? { images: itemData.images } : {}),
      ...(isCostSharing ? { cost_sharing: { company: companyRate, merchant: merchantRate } } : {}),
    }

    const isNewMerchantId = Object.keys(merchantIds).indexOf(selectedRestaurant) === -1

    if (action === 'edit') {
      await itemRef.update({ [`items.${selectedItem}`]: data })
    } else {
      const updates = {}

      if (isNewMerchantId) {
        updates.merchant_ids = { [selectedRestaurant]: true }
      }

      updates.items = { [selectedItem]: data }
      await itemRef.set(updates, { merge: true })
    }


    this.setState({ saving: false })
    saveDealItem(specialDealKey, { [selectedItem]: data })
    onClose()
  }

  generateDropDownItems = () => {
    const { selectedRestaurant } = this.state
    const { items } = this.props
    const itemOfSelectedRestaurant = _.pickBy(items[selectedRestaurant], item => item.status !== 'draft')

    const itemOptions = _.map(itemOfSelectedRestaurant, (item, key) => ({
      label: `${item.name} (${Number(item.current_price).toFixed(2)}$)`,
      value: key,
    }))

    return itemOptions
  }

  render() {
    const {
      isCostSharing,
      merchantRate,
      companyRate,
      selectedRestaurant,
      enableUserLimitation,
      selectedItem,
      discountRate,
      limitPerUser,
      quantity,
      unlimit,
      saving,
    } = this.state
    const { action, onClose, restaurants, itemsLoading } = this.props
    const disable =
      selectedRestaurant === null || selectedItem === null || discountRate === 0 || saving || (!unlimit && quantity === 0 )

    return (
      <Modal open size="small" style={{ marginTop: 0 }}>
        <Header content={action === 'edit' ? 'Edit Items' : 'Add New Items'} />
        <Modal.Content style={{ maxHeight: 500, overflow: 'auto' }} className="branch-form">
          {action === 'edit' && itemsLoading ? (
            <Dimmer active>
              <Loader active />
            </Dimmer>
          ) : (
            <Form onSubmit={this.onSavePress}>
              {action === 'new' && (
                <React.Fragment>
                  <Form.Group widths="equal">
                    <RestaurantField
                      restaurants={restaurants}
                      value={selectedRestaurant}
                      onChange={value => this.setState({ selectedRestaurant: value })}
                    />

                    <ItemField
                      selectedRestaurant={selectedRestaurant}
                      itemOptions={this.generateDropDownItems()}
                      value={selectedItem}
                      onChange={value => this.setState({ selectedItem: value })}
                    />
                  </Form.Group>
                </React.Fragment>
              )}

              <Form.Group widths="equal">
                <LimitationField
                  value={unlimit ? 'unlimit' : 'limit'}
                  onChange={value => this.setState({ unlimit: value === 'unlimit' })}
                />
                <QuantityField
                  disabled={unlimit}
                  value={quantity}
                  onChange={value => this.setState({ quantity: Number(value) })}
                />
              </Form.Group>

              <Form.Group widths="equal">
                <UserLimitationField
                  value={Boolean(enableUserLimitation)}
                  onChange={value => this.setState({ enableUserLimitation: value })}
                />
                <QuantityField
                  disabled={!enableUserLimitation}
                  value={limitPerUser}
                  onChange={value => this.setState({ limitPerUser: value })}
                />
              </Form.Group>

              <Form.Group widths="equal">
                <DiscountField
                  onChange={value => this.setState({ discountRate: Number(value) })}
                  value={discountRate}
                />
                <Form.Field
                  style={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    marginTop: 20,
                  }}
                >
                  <Checkbox
                    label="Share Expense"
                    checked={isCostSharing}
                    onChange={this.onShareExpenseCheck}
                    disabled={discountRate === 0}
                  />
                </Form.Field>
              </Form.Group>

              {isCostSharing && (
                <Form.Group widths="equal">
                  <ShareExpense
                    label="Company Rate"
                    value={companyRate}
                    onChange={value => this.setState({ companyRate: value })}
                  />
                  <ShareExpense
                    label="Merchant Rate"
                    value={merchantRate}
                    onChange={value => this.setState({ merchantRate: value })}
                  />
                </Form.Group>
              )}

              <button
                type="submit"
                hidden
                ref={ref => {
                  this.btnSubmitRef = ref
                }}
              />
            </Form>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose}>Close</Button>
          <Button
            icon
            color="black"
            loading={saving}
            disabled={disable}
            onClick={() => this.btnSubmitRef.click()}
          >
            <Icon name="checkmark" /> {action === 'new' ? 'Save' : 'Update'}
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

const mapState = ({ items }) => ({
  items: items.data,
  itemsLoading: items.loading,
})

const mapDispatch = {
  fetchItems: ItemActions.fetchItemsByRestaurant,
  saveDealItem: SpecialDealActions.saveDealItem,
}

export default connect(
  mapState,
  mapDispatch
)(NewItemForm)



// WEBPACK FOOTER //
// ./src/components/specialDeal/forms/newItemForm.js